<template>
    <div class="work-item" :class="{'work-item--expanded': isOpened}" @mouseenter="onEnter" @mouseleave="onLeave">
        <h2 class="work-item__name" @click="onClick">{{title}}</h2>
        <expand-transition>
            <div class="work-item__details" v-show="isExpanded">
                <slot name="description"></slot>
                <slot name="sounds"></slot>
            </div>
        </expand-transition>
    </div>
</template>
<script>
    import anime from 'animejs'
    export default {
        name: '',
        props: {
            title: {
                type: String,
                required: true
            },
            bgColour: {
                type: String,
                default: '#FFF6EC'
            }
        },
        data() {
            return {
                isExpanded: false,
                isOpened: false,
                isIn: null
            }
        },
        methods: {
            onEnter() {
                this.isIn = true
                if(!this.isIn) return
                this.isExpanded = true
                this.tl = anime.timeline()
                .add({
                    targets: '#app',
                    background: this.bgColour,
                    duration: 600,
                    easing: 'easeInOutCubic'
                })
                setTimeout(() => {
                    this.isOpened = true
                }, 150)
            },
            onLeave() {
                if(this.tl) this.tl.pause()
                this.isIn = false
                this.isExpanded = false
                this.isOpened = false
            },
            onClick() {
                if(this.isOpened) {
                    this.isExpanded = false
                    this.isOpened = false
                    this.$emit('leave')
                } else {
                    this.onEnter()
                }
            }
        }
    }
</script>
<style>
</style>